import { useEffect, useRef } from "react";
import { resubscribeRoomChannels } from "../services/chatPusher.service";

/**
 * The hidden flag is signed into a room's presence data when the channel is
 * joined, so open rooms must re-authenticate whenever it changes. Mounted once
 * at the app root, it is the single trigger for both this tab's switch and the
 * `chat_visibility_changed` event from another tab.
 */
export function useRoomChannelsReauth(isChatHidden: boolean) {
  const previousIsChatHidden = useRef(isChatHidden);

  useEffect(() => {
    if (previousIsChatHidden.current === isChatHidden) return;
    previousIsChatHidden.current = isChatHidden;
    resubscribeRoomChannels();
  }, [isChatHidden]);
}
